// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".archived-insurance-details-block[data-v-3f5dca9a] {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.archived-insurance-details-block .each-block[data-v-3f5dca9a] {\n  margin-bottom: 1rem;\n  border: 1px solid #dcdcdc;\n  border-radius: 15px;\n  padding: 10px;\n}\n.archived-insurance-details-block .each-block[data-v-3f5dca9a]:nth-last-child(1) {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
